"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeImproperList = exports.makeList = exports.makePair = void 0;
const sExpression_1 = require("../sExpression");
const makePair = (head, tail, loc) => {
    const location = loc !== null && loc !== void 0 ? loc : ('loc' in head && head.loc ? head.loc : 'loc' in tail && tail.loc ? tail.loc : undefined);
    return { type: 'pair', head, tail, loc: location };
};
exports.makePair = makePair;
const makeList = (values, loc) => {
    const sentinel = { tail: sExpression_1.makeEmptyList() };
    let prev = sentinel;
    for (const value of values) {
        const newTail = exports.makePair(value, sExpression_1.makeEmptyList());
        prev.tail = newTail;
        prev = newTail;
    }
    sentinel.tail.loc = loc;
    return sentinel.tail;
};
exports.makeList = makeList;
/** Create an improper list where the values before the dot are `beforeDot` and the value after the dot is `afterDot`. */
const makeImproperList = (beforeDot, afterDot, loc) => {
    const preList = exports.makeList(beforeDot);
    let curr = preList;
    while (curr.tail.type !== 'empty list') {
        curr = curr.tail;
    }
    curr.tail = afterDot;
    preList.loc = loc;
    return preList;
};
exports.makeImproperList = makeImproperList;
//# sourceMappingURL=value.js.map